module.exports = __webpack_public_path__ + "images/emoji/wink.d59e7c0ddbb779ce9d7d.png";